export default __webpack_public_path__ + "static/media/slider-img21.53550ce1.jpg";